import React from 'react';
import styles from '../LandingPage.module.css';

const EcosystemFlow = () => {
  const steps = [
    { title: 'Global Client', desc: 'Enterprise vision, business goals and outcomes.', icon: '🌐' },
    { title: 'Prohirey', desc: 'AI-driven talent acquisition & workforce intelligence.', icon: '👥' },
    { title: 'ToxBox AI', desc: 'Conversational AI, screening and process automation.', icon: '🤖' },
    { title: 'Engineering Teams', desc: 'Platform, AI and QA pods delivering at scale.', icon: '🔧' },
    { title: 'GCC Operations', desc: 'Run, govern and continuously optimise the GCC.', icon: '🏢' }
  ];

  return (
    <div className={styles.lightSection}>
      <div className={styles.section}>
        <div className={styles.pillLight}>
          <span style={{ color: '#3b82f6', fontSize: '1.2em', marginRight: '6px' }}>•</span> 
          GCC Operating Flow
        </div>
        <h2 className={styles.sectionTitleLight}>How the Provaantech ecosystem<br />operates</h2>
        <p className={styles.sectionSubtitleLight}>An AI-orchestrated flow from global client intent to running GCC operations.</p>
        
        <div className={styles.timelineContainer}>
          <div className={styles.timelineLine}></div>
          
          {steps.map((step, index) => (
            <div key={index} className={styles.timelineItem}>
              <div className={styles.timelineCardWrapper}>
                <div className={styles.timelineNode}></div>
                <div className={styles.timelineCard}>
                  <div className={styles.timelineIcon}>{step.icon}</div>
                  <div className={styles.timelineText}>
                    <h3>{step.title}</h3>
                    <p>{step.desc}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EcosystemFlow;
